import SafeProvider from '@safe-global/safe-apps-react-sdk';
import { ConfigProvider, theme } from 'antd';
import { Provider } from 'react-redux';
import { Switch } from 'react-router';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import LayoutDefault from './components/01.layout';
import { referralCodeIAO } from './helpers/storage';
import { THEME_MODE } from './interfaces/theme';
import { RainbowProvider } from './libs/rainbow';
import Routes from './routes/Routes';
import store, { useAppSelector } from './store';
import useVersionChecker from './useVersionCheck';

const AppRoutes = () => {
  useVersionChecker();
  const userTheme = useAppSelector((state: any) => state.theme);

  const darkMode = userTheme === THEME_MODE.DARK;
  localStorage.removeItem(referralCodeIAO);

  return (
    <ConfigProvider
      theme={{
        algorithm: darkMode ? theme.darkAlgorithm : theme.defaultAlgorithm,
        token: {
          fontFamily: 'Poppins',
        },
      }}
    >
      <LayoutDefault>
        <Routes />
      </LayoutDefault>
    </ConfigProvider>
  );
};

function App() {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <Switch>
          <SafeProvider>
            <RainbowProvider>
              <AppRoutes />
              <ToastContainer />
            </RainbowProvider>
          </SafeProvider>
        </Switch>
      </BrowserRouter>
    </Provider>
  );
}

export default App;
